export default {
    BASE_URL_MOCK: 'http://easymock.fe.corp.anjuke.com/mock/5fc065941e7f1427df6ecd98/yundiantong_company/',
    BASE_URL: '/api/',
    MOCK: true,
    TIMEOUT: 10000
};



//////////////////
// WEBPACK FOOTER
// ./src/request/default.ts
// module id = null
// module chunks = 